import { SmbContent } from 'shared/components/SmbPage';
import { FaqContainer } from 'shared/containers/Faq';
import { SocialsContainer } from 'shared/containers/Socials';
import { StepsContainer } from 'shared/containers/Steps';
import { TStep } from 'shared/types/carousel';
import type { TFaqItem } from 'shared/types/faq';
import type { TSocials } from 'shared/types/socials';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { StartBlockContainer } from '../StartBlock';

export const SmbContentContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const steps = config.get<TStep[]>('b2b-marketing-guide-frontend.smb.steps') ?? [];
  const faqItems = config.get<TFaqItem[] | null>('b2b-marketing-guide-frontend.smb.faq');
  const socialsConfig = config.get<TSocials | null>('b2b-marketing-guide-frontend.smb.socials');
  const faq = faqItems?.length ? <FaqContainer items={faqItems} compactTop={steps.length % 2 === 0} /> : null;
  const socials = socialsConfig ? <SocialsContainer socials={socialsConfig} /> : null;

  return (
    <SmbContent
      startBlock={<StartBlockContainer />}
      steps={<StepsContainer steps={steps} pageType="smb" />}
      faq={faq}
      socials={socials}
    />
  );
};
